import { AnimatePresenceComponent } from './AnimatePresenceComponent';

import BgMobile from '@/assets/backgrounds/404/bg_404-sm.jpg';
import BgDesktop from '@/assets/backgrounds/404/bg_404.jpg';
import { FullHeight, ResponsiveImage, Button } from '@/components';
import useAuth from '@/hooks/useAuth';

const GO_TOME_TEXT = 'Ir a inicio';

const Page404 = () => {
  const { isAuthenticated, isLoading } = useAuth();

  return (
    <AnimatePresenceComponent isLoaded={!isLoading}>
      <FullHeight className="flex flex-col">
        <div className="relative flex items-center justify-center flex-1 px-4 py-20">
          <ResponsiveImage
            alt="Fondo de balon en el campo"
            className="absolute inset-0 h-full w-full object-cover"
            desktopSrc={BgDesktop}
            mobileSrc={BgMobile}
          />
          <div className="relative max-w-2xl space-y-10 text-center w-full">
            <div className="mx-auto max-w-[245px] lg:max-w-full space-y-5 lg:space-y-10">
              <h1 className="text-[12.5rem] leading-[140px] lg:text-[18.75rem] lg:leading-[180px] text-white font-bebas font-medium lg:font-light">
                404
              </h1>
              <p className="text-base font-normal text-white">
                No encontramos la página que estás buscando,{' '}
                <br className="hidden lg:block" /> volvé al inicio para seguir
                navegando.
              </p>
            </div>
            <div>
              {isAuthenticated ? (
                <Button
                  className="w-full lg:w-auto py-[0.813rem] px-[2.57rem] rounded-[0.5rem]"
                  type="button"
                  variant="primary"
                  onClick={() => {
                    // With this fix, the isAuthenticated will be redirect the user
                    // To the page the user belongs.
                    window.location.reload();
                  }}
                >
                  {GO_TOME_TEXT}
                </Button>
              ) : (
                <Button
                  className="w-full lg:w-auto py-[0.813rem] px-[2.57rem] rounded-[0.5rem]"
                  href="/"
                  type="link"
                  variant="primary"
                >
                  {GO_TOME_TEXT}
                </Button>
              )}
            </div>
          </div>
        </div>
      </FullHeight>
    </AnimatePresenceComponent>
  );
};

export default Page404;
